import { render } from "./VongQuayVue.vue?vue&type=template&id=5729c5e5"
import script from "./VongQuayVue.vue?vue&type=script&lang=js"
export * from "./VongQuayVue.vue?vue&type=script&lang=js"

import "./VongQuayVue.vue?vue&type=style&index=0&id=5729c5e5&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__